var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHideOutline20 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.964 2.5A.75.75 0 0 1 8.958 1a11.921 11.921 0 0 1 5.918 1.578C16.566 3.558 18 5.068 18 7c0 1.003-.393 1.901-.999 2.659a.75.75 0 1 1-1.171-.937c.442-.553.67-1.13.67-1.722 0-1.13-.858-2.245-2.376-3.125A10.411 10.411 0 0 0 8.964 2.5ZM3.124 11.422C4.844 12.42 7.036 13 9 13c1.605 0 3.355-.388 4.873-1.066l.847.846a.75.75 0 1 0 1.06-1.06L4.28.22a.75.75 0 1 0-1.06 1.06l.823.824c-.974.445-1.87 1.02-2.57 1.712C.606 4.672 0 5.752 0 7c0 1.932 1.433 3.443 3.124 4.422ZM7.5 7a1.5 1.5 0 0 0 2.53 1.09L7.91 5.97c-.254.269-.41.631-.41 1.03ZM6 7a3 3 0 0 0 5.09 2.151l1.635 1.635c-1.201.458-2.523.714-3.725.714-1.702 0-3.635-.513-5.124-1.376C2.358 9.244 1.5 8.13 1.5 7c0-.731.35-1.449 1.028-2.117.66-.653 1.593-1.217 2.66-1.635l1.66 1.661A2.99 2.99 0 0 0 6 7Z",
    fill: "currentColor"
  })));
};
export default SvgHideOutline20;